import type { Theme } from '@mui/material';

export const styles = {
  bulkEditStepper: (theme: Theme) => ({
    marginBottom: 1.5,
    '& .MuiStepLabel-labelContainer': {
      display: 'none',

      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
  }),
};
